import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceSettings } from "./-settings/WorkspaceSettings";

export const Route = createFileRoute("/$workspace/settings")({
  staticData: { title: "Workspace settings" },
  component: WorkspaceSettings,
});
